import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.tsx';
import { initTelemetry } from './utils/telemetry';
import './index.css';

initTelemetry();

import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

const queryClient = new QueryClient();

// Global API fetch interceptor to support environment-based API URL
const originalFetch = window.fetch;
window.fetch = function (input: RequestInfo | URL, init?: RequestInit) {
  let target = input;
  let baseUrl = (import.meta.env.VITE_API_URL as string) || '';
  
  // Guard against stale Cloudflare environment variables pointing to the dead us-west1 region
  if (baseUrl.includes('us-west1')) {
    baseUrl = 'https://caio-backend-452812547323.us-central1.run.app';
  }

  if (baseUrl) {
    const cleanBase = baseUrl.replace(/\/$/, '');
    if (typeof target === 'string' && target.startsWith('/api/')) {
      target = `${cleanBase}${target}`;
    } else if (target instanceof URL && target.pathname.startsWith('/api/')) {
      target = new URL(`${cleanBase}${target.pathname}${target.search}`, baseUrl);
    }
  }
  return originalFetch.call(window, target, init);
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  </StrictMode>,
);
